import { render, staticRenderFns } from "./grupoFormForm.vue?vue&type=template&id=115e44a2"
import script from "./grupoFormForm.vue?vue&type=script&lang=js"
export * from "./grupoFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports